import { assessments as assessmentsServices } from '@coligo-org/fe-common/services';
import { ErrorsActions } from '../error';
import logger from '../../../common/services/logService';
import { coursesTypes } from '../../reducers/types';

export const getAssessmentStart = () => ({
  type: coursesTypes.GET_ASSESSMENT_START,
});

export const getAssessmentEnd = () => ({
  type: coursesTypes.GET_ASSESSMENT_END,
});

export default ({ assessmentId, callback }) =>
  async dispatch => {
    try {
      dispatch(getAssessmentStart());
      const { data } = await assessmentsServices.getAssessment({
        assessmentId,
      });
      if (callback) callback(data);
    } catch (error) {
      logger.log(error);
      if (error.response) {
        dispatch(ErrorsActions.addError(error.response.data.message));
      }
    } finally {
      dispatch(getAssessmentEnd());
    }
  };
